module.exports = __webpack_public_path__ + "media/images/doc-icon-e6a89554087ab1aaaa6b63fdfb77fe0c.svg";